import Api from 'libs/api/index';

class ChooseCompanyApi extends Api {
  constructor() {
    super('admin/choose_companies/');
  }
}

export default ChooseCompanyApi;
